export const TrackingRegistry = {
  CampaignCreate: {
    surface: 'campaign_create',
    elements: {
      SaveDraft: 'save_draft',
      NextStep: 'next_step',
      PublishCampaign: 'publish_campaign',
      Details: 'details_step',
      Targeting: 'targeting_step',
      Offers: 'offers_step',
      Promote: 'promote_step',
      Crm: 'crm_step',
      Review: 'review_step',
    },
  },
} as const

type Registry = typeof TrackingRegistry

export type TrackingEntry = {
  [K in keyof Registry]: {
    surface: Registry[K]['surface']
    element: Registry[K]['elements'][keyof Registry[K]['elements']]
  }
}[keyof Registry]

export type CampaignCreateElement =
  (typeof TrackingRegistry.CampaignCreate.elements)[keyof typeof TrackingRegistry.CampaignCreate.elements]

export const campaignCreateEntry = (element: CampaignCreateElement): TrackingEntry => ({
  surface: TrackingRegistry.CampaignCreate.surface,
  element,
})

export const getTrackingEntry = (
  surface: string | null,
  element: string | null
): TrackingEntry | undefined => {
  if (!surface || !element) return undefined

  const registrySurface = Object.values(TrackingRegistry).find(entry => entry.surface === surface)
  if (
    !registrySurface ||
    !Object.values(registrySurface.elements).some(value => value === element)
  ) {
    return undefined
  }

  return { surface, element } as TrackingEntry
}
